import { createSlice } from "@reduxjs/toolkit";
import {
  getAllCollections,
  createNewCollection,
  getOneCollection,
  addToCollection,
  removeFromCollection,
  deleteOneCollection,
} from "./collections-actions";

const collectionsSlice = createSlice({
  name: "collections",
  initialState: {
    loading: true,
    collections: [],
    error: "",
  },
  reducers: {},
  extraReducers: {
    [getAllCollections.fulfilled]: (state, action) => {
      state.loading = false;
      state.collections = action.payload.collections;
    },
    [getAllCollections.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    [createNewCollection.fulfilled]: (state, action) => {
      state.loading = false;
      state.collections = action.payload.collections;
    },
    [createNewCollection.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    [getOneCollection.fulfilled]: (state, action) => {
      state.loading = false;
      state.collections = action.payload.collections;
    },
    [getOneCollection.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    [addToCollection.fulfilled]: (state, action) => {
      state.loading = false;
      state.collections = action.payload.collections;
    },
    [addToCollection.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    [removeFromCollection.fulfilled]: (state, action) => {
      state.loading = false;
      state.collections = action.payload.collections;
    },
    [removeFromCollection.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    [deleteOneCollection.fulfilled]: (state, action) => {
      state.loading = false;
      state.collections = action.payload.collections;
    },
    [deleteOneCollection.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const collectionsActions = collectionsSlice.actions;
export default collectionsSlice;
